(() => {
  const normalizeHcUrl = (value) => {
    if (!value) return "";
    let decoded = value;
    let attempts = 0;
    while (attempts < 3) {
      try {
        const next = decodeURIComponent(decoded);
        if (next === decoded) break;
        decoded = next;
      } catch (error) {
        break;
      }
      attempts += 1;
    }
    decoded = decoded.split("?")[0];
    if (decoded.startsWith("http")) {
      try {
        decoded = new URL(decoded).pathname;
      } catch (error) {
      }
    }
    return decoded;
  };

  const schemaMapUrl = (() => {
    const script = document.querySelector("script[data-schema-map-url]");
    return script?.getAttribute("data-schema-map-url") || null;
  })();

  const SCHEMA_ATTR = "data-custom-schema";

  const removeInjectedSchemas = () => {
    document.querySelectorAll(`script[${SCHEMA_ATTR}]`).forEach((node) => node.remove());
  };

  const injectSchema = (schema) => {
    if (!schema || !document.head) return;
    removeInjectedSchemas();
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.setAttribute(SCHEMA_ATTR, "true");
    script.text = JSON.stringify(schema);
    document.head.appendChild(script);
  };

  const fetchSchemaMap = async () => {
    if (!schemaMapUrl) return null;
    try {
      const response = await fetch(schemaMapUrl, { credentials: "same-origin" });
      if (!response.ok) return null;
      return await response.json();
    } catch (error) {
      return null;
    }
  };

  let cachedSchemaMap = null;
  let lastKey = "";

  const getSchemaMap = async () => {
    if (cachedSchemaMap) return cachedSchemaMap;
    cachedSchemaMap = await fetchSchemaMap();
    return cachedSchemaMap;
  };

  const handleCustomSchema = async () => {
    const params = new URLSearchParams(window.location.search);
    const hcUrl = normalizeHcUrl(params.get("hcUrl"));
    if (!hcUrl || hcUrl === lastKey) return;
    lastKey = hcUrl;
    const schemaMap = await getSchemaMap();
    if (!schemaMap) return;
    injectSchema(schemaMap[hcUrl]);
  };

  let pending = false;
  const scheduleHandle = () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => {
      pending = false;
      handleCustomSchema();
    });
  };

  const removeRogueSchema = (node) => {
    if (node.nodeType === 1 && node.tagName === 'SCRIPT' && node.getAttribute('type') === 'application/ld+json') {
      if (!node.hasAttribute(SCHEMA_ATTR)) {
        try {
          const content = node.innerHTML.replace(/\s/g, ''); 
          if (content.includes('"@type":"FAQPage"')) {
            node.remove();
            console.log('Rogue app FAQ schema removed successfully.');
          }
        } catch (e) {
        }
      }
    }
  };

  const sweepExistingSchemas = () => {
    const schemas = document.querySelectorAll(`script[type="application/ld+json"]:not([${SCHEMA_ATTR}])`);
    schemas.forEach(removeRogueSchema);
  };

  const observer = new MutationObserver((mutations) => {
    let domChanged = false;
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length > 0) domChanged = true;
      mutation.addedNodes.forEach((node) => {
        removeRogueSchema(node);
      });
    });
    if (domChanged) scheduleHandle();
  });

  if (document.documentElement) {
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  const runStateChanges = () => {
    scheduleHandle();
    setTimeout(sweepExistingSchemas, 100); // Give the app a split second to render
  };

  if (document.readyState === "complete") {
    runStateChanges();
  } else {
    window.addEventListener("load", runStateChanges);
  }

  window.addEventListener("popstate", runStateChanges);

  ["pushState", "replaceState"].forEach((method) => {
    const original = history[method];
    history[method] = function (...args) {
      const result = original.apply(this, args);
      runStateChanges();
      return result;
    };
  });

  sweepExistingSchemas();

})();